import { withInstall } from '../../../utils/with-install'
import PulseLineLayer from './PulseLineLayer.vue'

export const ElAmapLocaPulseLine = withInstall(PulseLineLayer)
export default ElAmapLocaPulseLine
